import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Typography, Button, Box, Paper, Container, useTheme } from '@mui/material';
import HeadsetIcon from '@mui/icons-material/Headset';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { LanguageContext } from '../contexts/LanguageContext';
var FindQuietPlace = function (_a) {
    var onProceed = _a.onProceed;
    var t = useContext(LanguageContext).t;
    var theme = useTheme();
    return (_jsx(Container, { maxWidth: "sm", sx: {
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            py: 2
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                p: { xs: 2, sm: 4 },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                borderRadius: 2,
                bgcolor: 'background.paper',
                width: '100%',
                minHeight: { xs: 'calc(100vh - 120px)', sm: 'auto' }
            }, children: [_jsx(Typography, { variant: "h4", component: "h1", gutterBottom: true, align: "center", children: t('findQuietPlaceTitle') }), _jsxs(Box, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        my: 4,
                        gap: 4
                    }, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }, children: _jsx(VolumeOffIcon, { sx: { fontSize: 60, color: theme.palette.primary.main } }) }), _jsx(Box, { sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }, children: _jsx(HeadsetIcon, { sx: { fontSize: 60, color: theme.palette.primary.main } }) })] }), _jsx(Typography, { variant: "h6", align: "center", paragraph: true, children: t('findQuietPlaceDesc') }), _jsx(Button, { variant: "contained", color: "primary", size: "large", onClick: onProceed, sx: { mt: 4, py: 1.5, px: 4 }, children: t('proceedToBreathing') })] }) }));
};
export default FindQuietPlace;
